import React from "react";

/**
 * R6 B3 — Source Performance (bar chart + table).
 */
export default function SourcePerformanceDetail({ rows = [], onDrill }) {
  const max = rows.reduce((m, r) => Math.max(m, r.total), 0) || 1;
  return (
    <div className="r6-analytics-block">
      <h3 className="r6-analytics-title">Source Performance</h3>
      <div className="r6-source-bars">
        {rows.map((r) => (
          <button
            key={r.source}
            type="button"
            className="r6-source-bar-row"
            onClick={() => onDrill?.({ leadSource: r.source })}
          >
            <span className="r6-source-bar-label">{r.source}</span>
            <span className="r6-source-bar-track">
              <span
                className="r6-source-bar-fill"
                style={{ width: `${Math.round((r.total / max) * 100)}%` }}
              />
            </span>
            <span className="r6-source-bar-count">{r.total}</span>
          </button>
        ))}
      </div>
      <div className="r6-analytics-table-wrap">
        <table className="r6-analytics-table">
          <thead>
            <tr>
              <th>Source</th>
              <th>Total</th>
              <th>Won</th>
              <th>Conversion</th>
              <th>Open</th>
              <th>Avg Days to Close</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr><td colSpan={6} className="r6-analytics-empty">No data</td></tr>
            )}
            {rows.map((r) => (
              <tr key={r.source}>
                <td
                  className="r6-analytics-clickable"
                  onClick={() => onDrill?.({ leadSource: r.source })}
                >
                  {r.source}
                </td>
                <td>{r.total}</td>
                <td
                  className="r6-analytics-clickable"
                  onClick={() => onDrill?.({ leadSource: r.source, status: "Won" })}
                >
                  {r.won}
                </td>
                <td>{r.conversion_pct}%</td>
                <td>{r.open}</td>
                <td>{r.avg_days_to_close ?? "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}